import { render, staticRenderFns } from "./PunchDashboard.vue?vue&type=template&id=e71bc314&"
import script from "./PunchDashboard.vue?vue&type=script&lang=js&"
export * from "./PunchDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VDataTable})
